import { render } from "./aio-login-cards.vue?vue&type=template&id=30127187&scoped=true"
import script from "./aio-login-cards.vue?vue&type=script&lang=js"
export * from "./aio-login-cards.vue?vue&type=script&lang=js"

import "./aio-login-cards.vue?vue&type=style&index=0&id=30127187&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30127187"]])

export default __exports__